import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/supplier-set',
      name: 'admin-supplier-set',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-supplier-set" */ `./1.0.3/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "平台设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "供应商列表"
                                        },
                                        {
                                                  name: "平台设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
